/**
 * 身份的权重
 */
export const VIPWEIGHT = {
  // 免费
  // freeVip: 0,
  // // 初级
  // basicVip: 10,
  // // 高级
  // advancedVip: 30,
  // // 企业用户
  // enterpriseVip: 100,

  // 免费
  freeVip: 1,
  // 初级
  basicVip: 2,
  // 高级
  advancedVip: 3,
  // 企业用户
  enterpriseVip: 4,
};

// export const VipSpaceStorage = {
//   freeVip: 500 * 1024 * 1024, // 500M
//   basicVip: 1000 * 1024 * 1024, // 1G
//   advancedVip: 10 * 1000 * 1024 * 1024, // 10G
//   enterpriseVip: 9999 * 1000 * 1024 * 1024, // 永久
// };

// export const VipCloudStorage = {
//   freeVip: 7, // 7天
//   basicVip: 30, // 30天
//   advancedVip: 60, // 60天
//   enterpriseVip: 99999, // 永久
// };

export const qaFunctionMock = {
  code: 200,
  data: {
    advancedVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 3,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量(单位MB) ',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 30,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 30,
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fImageTextTranslate',
        funcTitle: '3.2图片翻译',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '爆款视频复刻',
      },
    ],
    basicVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 2,
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 5,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 5,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量(单位MB) ',
        functionLimit: 1024000,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fImageTextTranslate',
        funcTitle: '3.2图片翻译',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '爆款视频复刻',
      },
    ],
    commodity: [
      {
        commodityCode: '1788610375709904896',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4574,
          point: 300,
          sonRightIds: [4574],
        },
        desc: '300积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4574,"sonRightIds":[4574],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TblNlhbYnzEHhd","plan":"price_1SmYXMJpRT95MkIJ2sNtAAbR"}',
        increaseTime: 1769161292666,
        modelCode: '1',
        originalPrice: 4600,
        realPrice: 4600,
        sort: 9919,
        title: 'AI-积分包-46',
      },
      {
        commodityCode: '1788610334089826304',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4495,
          point: 600,
          sonRightIds: [4495],
        },
        desc: '600积分',
        discount: 0.651163,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4495,"sonRightIds":[4495],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TblNlhbYnzEHhd","plan":"price_1SmYZ7JpRT95MkIJ7Xm4yFiy"}',
        increaseTime: 1767699426575,
        modelCode: '1',
        originalPrice: 8600,
        realPrice: 5600,
        sort: 9920,
        title: 'AI积分包-56',
      },
      {
        commodityCode: '1788610374527111168',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100035,
          point: 1000,
          sonRightIds: [100035],
        },
        desc: '1000积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100035,"sonRightIds":[100035],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TblNlhbYnzEHhd","plan":"price_1SmYZwJpRT95MkIJtygZfQYc"}',
        increaseTime: 1767699486249,
        modelCode: '1',
        originalPrice: 11800,
        realPrice: 11800,
        sort: 9921,
        title: 'AI积分-118',
      },
      {
        commodityCode: '1788610341182394368',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100036,
          point: 2000,
          sonRightIds: [100036],
        },
        desc: '2000积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100036,"sonRightIds":[100036],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TblNlhbYnzEHhd","plan":"price_1Smv5XJpRT95MkIJp02ffZLi"}',
        increaseTime: 1767785995719,
        modelCode: '1',
        originalPrice: 19800,
        realPrice: 19800,
        sort: 9922,
        title: 'AI积分包-198',
      },
      {
        commodityCode: '1788610322953949184',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4390,
          point: 3600,
          sonRightIds: [4400, 4401, 4406, 4409, 47300, 4390],
        },
        desc: '每月55',
        discount: 0.696203,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4390,"sonRightIds":[4400,4401,4406,4409,47300,4390],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TblNlhbYnzEHhd","plan":"price_1TF6YLJpRT95MkIJxqQvVELg","isWorkflow":0}',
        increaseTime: 1774503250665,
        modelCode: '1',
        originalPrice: 94800,
        realPrice: 66000,
        sort: 9923,
        title: '高级-年-660',
      },
      {
        commodityCode: '1788610310371037184',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4726,
          point: 1200,
          sonRightIds: [4398, 4399, 4408, 4405, 47310, 4726],
        },
        desc: '每月25',
        discount: 0.862069,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4726,"sonRightIds":[4398,4399,4408,4405,47310,4726],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TRExDh3SzYNWz3","plan":"price_1TF6XvJpRT95MkIJZAzlKd1T","isWorkflow":0}',
        increaseTime: 1774503264901,
        modelCode: '1',
        originalPrice: 34800,
        realPrice: 30000,
        sort: 9925,
        title: '初级-年-300',
      },
      {
        commodityCode: '1788610375315640320',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4729,
          point: 300,
          sonRightIds: [4401, 4400, 4406, 4409, 4732, 4729],
        },
        desc: '专业-月-79',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4729,"sonRightIds":[4401,4400,4406,4409,4732,4729],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TRExDh3SzYNWz3","plan":"price_1TF6XYJpRT95MkIJIqdDAXvp","isWorkflow":0}',
        increaseTime: 1774503333917,
        modelCode: '1',
        originalPrice: 7900,
        realPrice: 7900,
        sort: 9935,
        title: '专业-月-79',
      },
      {
        commodityCode: '1788610346555297792',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4727,
          point: 100,
          sonRightIds: [4408, 4398, 4399, 4405, 4733, 4727],
        },
        desc: '初级-月-29',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4727,"sonRightIds":[4408,4398,4399,4405,4733,4727],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TRExDh3SzYNWz3","plan":"price_1TF6XIJpRT95MkIJE3Nl7bnO","isWorkflow":0}',
        increaseTime: 1774503357821,
        modelCode: '1',
        originalPrice: 2900,
        realPrice: 2900,
        sort: 9937,
        title: '初级-月-29',
      },
      {
        commodityCode: '1700534318952374272',
        commodityType: 10,
        content: {
          category: 'enterpriseVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          label: '',
          mainRightId: 4580,
          sonRightIds: [4410, 4403, 4402, 4580],
        },
        desc: '海外企业占位年包-误删',
        discount: 1,
        extend:
          '{"label":"","showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4580,"sonRightIds":[4410,4403,4402,4580],"restrictedPaymentChannels":[]}',
        increaseTime: 1766991531511,
        modelCode: '1',
        originalPrice: 999999,
        realPrice: 999999,
        sort: 9939,
        title: '海外企业占位年包-误删',
      },
      {
        commodityCode: '1679974859393990656',
        commodityType: 10,
        content: {
          category: 'freeVip',
          commodityName: 'cloud_vip_right',
          currency: 'USD',
          durationType: 5,
          label: '1',
          mainRightId: 4386,
          point: 20,
          sonRightIds: [4396, 4397, 4407, 4404, 4391, 4386],
        },
        desc: '免费商品展示海外',
        discount: 0,
        extend:
          '{"label":"1","showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4386,"sonRightIds":[4396,4397,4407,4404,4391,4386],"restrictedPaymentChannels":[],"modelCode":"1","isWorkflow":0}',
        increaseTime: 1773887984755,
        modelCode: '1',
        originalPrice: 0,
        realPrice: 0,
        sort: 9956,
        title: '免费商品展示海外',
      },
    ],
    enterpriseVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 100000000,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 20,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 4,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 100,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 100,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量(单位MB) ',
        functionLimit: 1024000,
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fImageTextTranslate',
        funcTitle: '3.2图片翻译',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '爆款视频复刻',
      },
    ],
    freeVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量(单位MB) ',
        functionLimit: 1024000,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 1,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 1,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 1,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fImageTextTranslate',
        funcTitle: '3.2图片翻译',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '爆款视频复刻',
      },
    ],
  },
  message: 'successful',
  success: true,
};

export const masterFunctionMock = {
  code: 200,
  data: {
    advancedVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'audioTranslate',
        funcTitle: '旁白翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'textEdit',
        funcTitle: '字体编辑',
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 3,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 30,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 30,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '3.5爆款视频复刻',
      },
    ],
    basicVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'audioTranslate',
        funcTitle: '旁白翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'textEdit',
        funcTitle: '字体编辑',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 1080,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 2,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 5,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 5,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '3.5爆款视频复刻',
      },
    ],
    commodity: [
      {
        commodityCode: '1776677479306809344',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4644,
          point: 100,
          sonRightIds: [4652, 4407, 4397, 4398, 4404, 4644],
        },
        desc: '初级-月-29',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4644,"sonRightIds":[4652,4407,4397,4398,4404,4644],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RUXfAAMBmb7bZW","plan":"price_1SXbbnJg0YSXb5HsHarLVLxa"}',
        increaseTime: 1774606795140,
        modelCode: '1',
        originalPrice: 2900,
        realPrice: 2900,
        sort: 9879,
        title: '初级-月-29',
      },
      {
        commodityCode: '1776676837943197696',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4643,
          point: 1200,
          sonRightIds: [4650, 4398, 4397, 4404, 4407, 4643],
        },
        desc: '每月25',
        discount: 0.862069,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4643,"sonRightIds":[4650,4398,4397,4404,4407,4643],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RUXfAAMBmb7bZW","plan":"price_1TFUWNJg0YSXb5HsgVDU2kPL"}',
        increaseTime: 1774606299234,
        modelCode: '1',
        originalPrice: 34800,
        realPrice: 30000,
        sort: 9881,
        title: '初级-年-300',
      },
      {
        commodityCode: '1776676145526521856',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4646,
          point: 300,
          sonRightIds: [4651, 4405, 4399, 4400, 4408, 4646],
        },
        desc: '专业-月-79',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4646,"sonRightIds":[4651,4405,4399,4400,4408,4646],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RUXhqmlfi0fBwO","plan":"price_1TFUUiJg0YSXb5HsUm6MzgrT"}',
        increaseTime: 1774606299142,
        modelCode: '1',
        originalPrice: 7900,
        realPrice: 7900,
        sort: 9883,
        title: '专业-月-79',
      },
      {
        commodityCode: '1776675348608761856',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4645,
          point: 3600,
          sonRightIds: [4649, 4405, 4408, 4399, 4400, 4645],
        },
        desc: '每月55',
        discount: 0.696203,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4645,"sonRightIds":[4649,4405,4408,4399,4400,4645],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RUXhqmlfi0fBwO","plan":"price_1TFUVBJg0YSXb5Hs1jKhsyJu"}',
        increaseTime: 1774606299340,
        modelCode: '1',
        originalPrice: 94800,
        realPrice: 66000,
        sort: 9885,
        title: '高级-年-660',
      },
      {
        commodityCode: '1776669908948795392',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4591,
          point: 300,
          sonRightIds: [4591],
        },
        desc: '300积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4591,"sonRightIds":[4591],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RXcftEi6BIxozY","plan":"price_1SXbdsJg0YSXb5HsQncK8WPE"}',
        increaseTime: 1764569811163,
        modelCode: '1',
        originalPrice: 4600,
        realPrice: 4600,
        sort: 9887,
        title: 'AI-积分包-46',
      },
      {
        commodityCode: '1776670999740469248',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4653,
          point: 600,
          sonRightIds: [4653],
        },
        desc: '600积分',
        discount: 0.651163,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4653,"sonRightIds":[4653],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RXcftEi6BIxozY","plan":"price_1SZQlZJg0YSXb5HsZxjWgKT2"}',
        increaseTime: 1764571191122,
        modelCode: '1',
        originalPrice: 8600,
        realPrice: 5600,
        sort: 9888,
        title: 'AI积分包-56',
      },
      {
        commodityCode: '1776671690890465280',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4648,
          point: 1000,
          sonRightIds: [4648],
        },
        desc: '1000积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4648,"sonRightIds":[4648],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RXcftEi6BIxozY","plan":"price_1SXbeBJg0YSXb5HsjV5Lk2Ji"}',
        increaseTime: 1764569831121,
        modelCode: '1',
        originalPrice: 11800,
        realPrice: 11800,
        sort: 9889,
        title: 'AI积分-118',
      },
      {
        commodityCode: '1776673264119365632',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4647,
          point: 2000,
          sonRightIds: [4647],
        },
        desc: '2000积分',
        discount: 1,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4647,"sonRightIds":[4647],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RXcftEi6BIxozY","plan":"price_1SXbeMJg0YSXb5HsrkcZBOux"}',
        increaseTime: 1764569841090,
        modelCode: '1',
        originalPrice: 19800,
        realPrice: 19800,
        sort: 9890,
        title: 'AI积分包-198',
      },
      {
        commodityCode: '1663250094243500032',
        commodityType: 10,
        content: {
          category: 'freeVip',
          commodityName: 'cloud_vip_right',
          currency: 'USD',
          durationType: 2,
          label: '',
          mainRightId: 4385,
          point: 10,
          sonRightIds: [4390, 4385],
        },
        desc: '免费会员展示USD',
        discount: 1,
        extend:
          '{"label":"","showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4385,"sonRightIds":[4390,4385],"restrictedPaymentChannels":[],"modelCode":"1"}',
        increaseTime: 1766737139125,
        modelCode: '1',
        originalPrice: 0,
        realPrice: 0,
        sort: 9959,
        title: '免费会员展示USD',
      },
      {
        commodityCode: '1663189641626701824',
        commodityType: 10,
        content: {
          category: 'enterpriseVip',
          commodityName: 'cloud_vip_right',
          currency: 'CNY',
          label: '',
          mainRightId: 4410,
          point: 3600,
          sonRightIds: [4410, 4449],
        },
        desc: '企业会员展示',
        discount: 1,
        extend: '{"mainRightId":4410,"label":"","sonRightIds":[4410,4449]}',
        increaseTime: 1737089775119,
        modelCode: '1',
        originalPrice: 9999999,
        realPrice: 9999999,
        sort: 9980,
        title: '企业会员展示',
      },
    ],
    enterpriseVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'audioTranslate',
        funcTitle: '旁白翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'textEdit',
        funcTitle: '字体编辑',
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 100000000,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 4,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 100,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 100,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '3.5爆款视频复刻',
      },
    ],
    freeVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 720,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 1,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 1,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 1,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fImgUpscaler',
        funcTitle: '3.1图片高清',
      },
      {
        funcName: 'fSingleImgTrans',
        funcTitle: '3.1图片翻译',
      },
      {
        funcName: 'fCaptionClearoff',
        funcTitle: '3.1视频擦除',
      },
      {
        funcName: 'fVideoEdit',
        funcTitle: '3.2视频编辑',
      },
      {
        funcName: 'fViraRemake',
        funcTitle: '3.5爆款视频复刻',
      },
    ],
  },
  message: 'successful',
  success: true,
};
